function initializeMobileMenu() {
  const openButton = document.getElementById("MobileMenuButton");
  const closeButton = document.getElementById("MobileMenuClose");
  const drawer = document.getElementById("MobileMenuDrawer");
  const overlay = document.getElementById("MobileMenuOverlay");

  if (!openButton || !closeButton || !drawer || !overlay) {
    return;
  }

  if (openButton.dataset.menuReady === "true") {
    return;
  }

  openButton.dataset.menuReady = "true";

  function openMenu() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    openButton.setAttribute("aria-expanded", "true");
    overlay.hidden = false;
    document.body.classList.add("mobile-menu-open");
  }

  function closeMenu() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    openButton.setAttribute("aria-expanded", "false");
    overlay.hidden = true;
    document.body.classList.remove("mobile-menu-open");
  }

  openButton.addEventListener("click", openMenu);
  closeButton.addEventListener("click", closeMenu);
  overlay.addEventListener("click", closeMenu);

  drawer.querySelectorAll("a").forEach(function (link) {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeMenu();
    }
  });
}

document.addEventListener("DOMContentLoaded", initializeMobileMenu);
document.addEventListener("shopify:section:load", initializeMobileMenu);

function initializeDealCountdown() {
  const dealSection = document.getElementById("shop-deals");

  if (!dealSection) return;

  const endDateValue = dealSection.dataset.end;

  const daysElement = document.getElementById("days");
  const hoursElement = document.getElementById("hours");
  const minutesElement = document.getElementById("minutes");
  const secondsElement = document.getElementById("seconds");

  if (
    !endDateValue ||
    !daysElement ||
    !hoursElement ||
    !minutesElement ||
    !secondsElement
  ) {
    return;
  }

  const endTime = new Date(endDateValue).getTime();

  if (Number.isNaN(endTime)) {
    console.error("Invalid deal end date:", endDateValue);
    return;
  }

  if (dealSection.dataset.countdownReady === "true") return;
  dealSection.dataset.countdownReady = "true";

  function formatNumber(number) {
    return String(number).padStart(2, "0");
  }

  function updateCountdown() {
    const distance = endTime - Date.now();

    if (distance <= 0) {
      daysElement.textContent = "00";
      hoursElement.textContent = "00";
      minutesElement.textContent = "00";
      secondsElement.textContent = "00";

      clearInterval(dealSection.countdownTimer);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));

    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) /
      (1000 * 60 * 60)
    );

    const minutes = Math.floor(
      (distance % (1000 * 60 * 60)) /
      (1000 * 60)
    );

    const seconds = Math.floor(
      (distance % (1000 * 60)) / 1000
    );

    daysElement.textContent = formatNumber(days);
    hoursElement.textContent = formatNumber(hours);
    minutesElement.textContent = formatNumber(minutes);
    secondsElement.textContent = formatNumber(seconds);
  }

  updateCountdown();

  dealSection.countdownTimer = setInterval(updateCountdown, 1000);
}

document.addEventListener("DOMContentLoaded", initializeDealCountdown);
document.addEventListener("shopify:section:load", initializeDealCountdown);